import { Dimensions } from "react-native";
function getWindowFrame() {
  var { width, height } = Dimensions.get("window");
  return {
    x: 0,
    y: 0,
    width,
    height
  };
}
export {
  getWindowFrame
};
//# sourceMappingURL=getWindowFrame.native.js.map
